import { useTranslation } from 'react-i18next';
import {
  METADATA_CONDITION_OPERATORS,
  MetadataRunConditionOperator,
} from '@/Domain/api/Shared/dto/MetadataRunCondition.dto';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/Domain/components/Shared/Select/Select';

type Props = {
  id: string;
  value: MetadataRunConditionOperator;
  onChange: (operator: MetadataRunConditionOperator) => void;
};

export const MetadataConditionOperator = ({ id, value, onChange }: Props) => {
  const { t } = useTranslation('metadata_conditions');
  return (
    <Select
      value={value}
      onValueChange={(operator) => onChange(operator as MetadataRunConditionOperator)}
    >
      <SelectTrigger
        id={id}
        data-testid={id}
        className="w-full min-w-0"
        aria-label={t('condition')}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {METADATA_CONDITION_OPERATORS.map((operator) => (
            <SelectItem key={operator} value={operator}>
              {t(`operator.${operator}`)}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
